<template>
	<div>
		<Upload action="/file/img/sing" :on-success="onsuccess">
			<Button icon="ios-cloud-upload-outline">Upload files</Button>
		</Upload>
	</div>
</template>
<script>
	export default {
		data() {
			return {
			    img:{
					imgName:'',
					imgUrl:''
				}
			}
		},
		methods: {
			onsuccess(response, file, fileList) {
				if(response.code==200){
					this.img.imgUrl=response.url
					this.img.imgName=response.imgName
					console.log(this.img)
					//向父组件传值
					this.$emit('imgFile',img);
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/comm/img.vue